import React from 'react'
import Nav from '../Nav/index'
import Footer from '../Footer/index'
import Hero from './Hero/index'
import Content from './Content/index'

import { Helmet } from 'react-helmet'
import 'bootstrap/dist/css/bootstrap.css'
import './css/style.css'


function index() {

  return (
    <>

      <Helmet>
        <script async src="https://www.googletagmanager.com/gtag/js?id=AW-11084448289"></script>

        <title>Dos and Don'ts for Supporting Someone During Seizures | Kyno Health</title>
        <meta name="description" content="Learn the essential dos and don'ts for supporting someone during seizures with Kyno Health. Discover practical tips to ensure their safety and well-being during these critical moments." data-react-helmet="true" />

        <meta name="keywords" content="" data-react-helmet="true"/>

        <link rel="canonical" href="https://www.kynohealth.com/blog/support-during-seizures"/>
                     </Helmet>

      <Nav />
      <Hero />
      <Content />
      <Footer />
    </>
  )
}





export default index